import { render } from "./FBARemovesTheAddress.vue?vue&type=template&id=810813fc&scoped=true"
import script from "./FBARemovesTheAddress.vue?vue&type=script&lang=js"
export * from "./FBARemovesTheAddress.vue?vue&type=script&lang=js"

import "./FBARemovesTheAddress.vue?vue&type=style&index=0&id=810813fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-810813fc"]])

export default __exports__